import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";


export const getChargeAccountToDiscountsByUserId = (userId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
    var queryParams = userId;

    axiosActions
        .GET(SERVER_ROUTES.CHARGE_ACCOUNT_TO_DISCOUNT_BY_USER_ID, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            trackException(
                "ActionsService.js - getChargeAccountToDiscountsByUserId()",
                error
            );
            reject(error);
        });
    });
};

export const searchUserForValidation = (contactInfo, contactType, siteId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var queryParams =
      "?contactInfo=" + contactInfo + "&contactType=" + contactType + "&siteId=" + siteId;
  
      axiosActions
        .GET(SERVER_ROUTES.VALIDATIONS_SEARCH_USER, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - searchUserForValidation()",
            error
          );
          reject(error);
        });
    });
  };

  export const assignDiscountForToken = (assignDiscountTokenEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = assignDiscountTokenEntity;
  
      axiosActions
        .PATCH(SERVER_ROUTES.ASSIGN_DISCOUNT, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - assignDiscountForToken()",
            error
          );
          reject(error);
        });
    });
  };

  export const getValidationHistoriesByChargeAccountId = (chargeAccountId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
    var queryParams = chargeAccountId;

    axiosActions
        .GET(SERVER_ROUTES.VALIDATION_HISTORIES_BY_CHARGE_ACCOUNT_ID, queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            trackException(
                "ActionsService.js - getValidationHistoriesByChargeAccountId()",
                error
            );
            reject(error);
        });
    });
};

export const getValidationHistoriesBySiteIds = (siteIds, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = siteIds;

    axiosActions
      .POST(SERVER_ROUTES.VALIDATION_HISTORIES_BY_SITE_IDS, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getValidationHistoriesBySiteIds()",
          error
        );
        reject(error);
      });
  });
};